<template>
    <div>
        <h3>Long running task</h3>
        <div class="table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th>Task Id</th>
                        <th>TypeName (code)</th>
                        <th>Time</th>
                        <th>Account</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="task in tasks" :key="task.TaskId">
                        <td>{{ task.TaskId }}</td>
                        <td>
                            <span>{{ task.TypeName }}</span>
                            (<span>{{ task.Type }}</span>)
                        </td>
                        <td>{{ formatDateTime(task.Started) }}</td>
                        <td>{{ task.AccountName }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

